<template>
  <section class="page-section" v-loading="pageLoading">
    <el-tabs v-model="tabName" type="card" @tab-click="handleTabsChange">
      <el-tab-pane label="关于我们" name="3"></el-tab-pane>
      <el-tab-pane label="常见问题" name="4"></el-tab-pane>
      <!-- <el-tab-pane label="联系客服" name="5"></el-tab-pane> -->
    </el-tabs>

    <div class="background-height">
      <el-form
        size="small"
        ref="formBase"
        :model="formBase"
        label-width="80px"
        class="content-form"
        :rules="rules"
      >
        <div class="form-module">
          <div class="module-body">
            <el-form-item label="图片" prop="imageUrl">
              <div class="pics-box">
                <el-upload
                  :action="uploadUrl"
                  list-type="picture-card"
                  drag
                  :file-list="formBase.fileList"
                  :on-preview="handlePicturesPreview"
                  :on-remove="handlePicturesRemove"
                  :on-success="handlePicturesSuccess"
                  :on-error="handlePicturesError"
                  :before-upload="handlePicturesBeforeUpload"
                  :on-exceed="handlePicturesExceed"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <p class="imgTips">
                  支持jpg、png格式，上传数量不限，单张图片不超过500k
                </p>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                @click="submitForm('formBase')"
                :loading="saveLoading"
                >保存</el-button
              >
              <el-button type="default" size="small" plain>取消</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <el-dialog
        class="preview-modal"
        :visible.sync="imgVisible"
        append-to-body
      >
        <img width="100%" :src="dialogImageUrl" alt="photo" />
      </el-dialog>
    </div>
  </section>
</template>

<script>
import {
  uploadPath,
  distributorPosterManage,
  distributorIntroEcho,
} from "@/common/api";

export default {
  data() {
    return {
      tabName: this.$route.query.tabname ? this.$route.query.tabname : "3", // 选项卡name

      pageLoading: false, // 页面loading
      saveLoading: false, // 编辑保存按钮loading
      uploadUrl: uploadPath + "/distributorIntro/uploadPic", // 上传图片接口
      dialogImageUrl: "", // 原图片弹窗路径
      imgVisible: false, // 原图片弹窗是否显示
      formBase: {
        // 编辑表单
        imageUrl: [], // 图片prop正则
        fileList: [], // 上传图片信息储存
      },
      rules: {
        // 表单正则
        imageUrl: [{ required: true, message: "请上传图片", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 获取单个编辑信息
    getDetail() {
      this.pageLoading = true;
      var params = {
        type: this.tabName,
      };
      distributorIntroEcho(params)
        .then((res) => {
          if (res.code == 0) {
            this.pageLoading = false;
            this.formBase.fileList = [];
            res.data.path.forEach((item) => {
              this.formBase.fileList.push({ url: item });
            });
            res.data.url.forEach((item, index) => {
              this.formBase.fileList[index].imageUrl = item;
            });
          } else {
            this.$message({ message: res.msg, type: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error("服务器异常");
        });
    },

    // 图片上传之前
    handlePicturesBeforeUpload(file) {
      let fileName = file.name,
        fileNameArr = fileName.split("."),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ["jpg", "jpeg", "png"];

      if (supportArr.indexOf(fileType) == -1) {
        this.$message({
          message: "请上传jpg、jpeg、png格式的图片",
          type: "error",
        });
        return false;
      }
    },
    // 图片上传成功
    handlePicturesSuccess(response, file, fileList) {
      if (response.code == 0) {
        fileList[fileList.length - 1].imageUrl = response.data.url;
      }
      this.formBase.fileList = fileList;
      console.log("SUCCESS: ", response, file, fileList);
    },
    // 图片上传失败
    handlePicturesError(err, file, fileList) {
      console.log("ERROR: ", err, file, fileList);
    },
    // 图片数量超出限制
    handlePicturesExceed(files, fileList) {
      console.log("EXCEED: ", file, fileList);
    },
    // 图片删除
    handlePicturesRemove(file, fileList) {
      this.formBase.fileList = fileList;

      console.log("REMOVE: ", file, fileList);
    },
    // 图片预览
    handlePicturesPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgVisible = true;
    },
    // 切换选项卡
    handleTabsChange(tab, event) {
      this.tabName = tab.name;
      this.$router.push({
        path: "/shop/set",
        query: { tabname: this.tabName },
      });
      this.formBase.imageUrl = [];
      this.formBase.fileList = [];
      this.getDetail();
    },
    // 表单验证事件
    submitForm(formName) {
      this.formBase.fileList.forEach((item) => {
        this.formBase.imageUrl.push(item.imageUrl);
      });

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveLoading = true;
          var params = {
            id: this.$route.query.id,
            type: this.tabName,
            title: this.formBase.name,
            url: this.formBase.imageUrl.join(","),
          };
          distributorPosterManage(params)
            .then((res) => {
              this.saveLoading = false;
              if (res.code == 0) {
                this.$message({ message: "保存成功", type: "success" });
              } else {
                this.$message({ message: res.msg, type: "error" });
              }
            })
            .catch((error) => {
              this.saveLoading = false;
              this.$message.error("服务器异常");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {
    this.getDetail();
  },
};
</script>
<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

::v-deep .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 98px;
  border-radius: 2px;

  .el-upload-dragger {
    width: 98px;
    height: 98px;
    border: none;

    .el-icon-plus {
      font-size: $baseFS;
    }
  }
}
.pics-box .imgTips {
  color: $tipsColor;
}
::v-deep .el-upload-list__item .el-icon-close-tip {
  display: none;
}
.app-container .page-main .page-section .background-height {
  background-color: $colorWhite;
  padding-top: 10px;
}
.pics-box {
  ::v-deep .el-upload-list--picture-card {
    .el-upload-list__item {
      position: relative;
      width: 100px;
      height: 100px;
      border-radius: 2px;

      .el-upload-list__item-thumbnail {
        @include position(absolute, none, 50%, none, none, 50%);
        @include translate(-50%, -50%, 0);
      }

      .el-progress {
        width: 80px;
        height: 80px;

        .el-progress-circle {
          width: 80px !important;
          height: 80px !important;
        }
      }

      .el-icon-close-tip {
        display: none;
      }
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 98px;
    border-radius: 2px;

    .el-upload-dragger {
      width: 98px;
      height: 98px;
      border: none;

      .el-icon-plus {
        font-size: $baseFS;
      }
    }
  }
}
</style>
